/**
 * @generated SignedSource<<0d116f124e8b220b5193e27ced2a1e42>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditExternalLicenseInput = {
  clientMutationId?: string | null;
  data: ExternalLicenseDataInput;
  externalLicenseId: string;
};
export type ExternalLicenseDataInput = {
  code?: string | null;
  name?: string | null;
};
export type editExternalLicenseForm_EditExternalLicenseMutation$variables = {
  input: EditExternalLicenseInput;
};
export type editExternalLicenseForm_EditExternalLicenseMutation$data = {
  readonly Admin: {
    readonly Billing: {
      readonly editExternalLicense: {
        readonly externalLicense: {
          readonly data: {
            readonly name: string;
          };
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"editExternalLicenseForm_ExternalLicenseFragment">;
        };
      } | null;
    };
  };
};
export type editExternalLicenseForm_EditExternalLicenseMutation = {
  response: editExternalLicenseForm_EditExternalLicenseMutation$data;
  variables: editExternalLicenseForm_EditExternalLicenseMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "editExternalLicenseForm_EditExternalLicenseMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Billing",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditExternalLicensePayload",
                "kind": "LinkedField",
                "name": "editExternalLicense",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ExternalLicense",
                    "kind": "LinkedField",
                    "name": "externalLicense",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ExternalLicenseData",
                        "kind": "LinkedField",
                        "name": "data",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "editExternalLicenseForm_ExternalLicenseFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "editExternalLicenseForm_EditExternalLicenseMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Billing",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditExternalLicensePayload",
                "kind": "LinkedField",
                "name": "editExternalLicense",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ExternalLicense",
                    "kind": "LinkedField",
                    "name": "externalLicense",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ExternalLicenseData",
                        "kind": "LinkedField",
                        "name": "data",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "code",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ExternalLicensePool",
                        "kind": "LinkedField",
                        "name": "pool",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ExternalLicensePoolData",
                            "kind": "LinkedField",
                            "name": "data",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "validNumDaysAfterIssuing",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "usageInformation",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "issuingInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasBeenIssued",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5d6efe83592932a31a55b5eaa796afc8",
    "id": null,
    "metadata": {},
    "name": "editExternalLicenseForm_EditExternalLicenseMutation",
    "operationKind": "mutation",
    "text": "mutation editExternalLicenseForm_EditExternalLicenseMutation(\n  $input: EditExternalLicenseInput!\n) {\n  Admin {\n    Billing {\n      editExternalLicense(input: $input) {\n        externalLicense {\n          id\n          data {\n            name\n          }\n          ...editExternalLicenseForm_ExternalLicenseFragment\n        }\n      }\n    }\n  }\n}\n\nfragment editExternalLicenseForm_ExternalLicenseFragment on ExternalLicense {\n  id\n  data {\n    name\n    code\n  }\n  pool {\n    id\n    data {\n      validNumDaysAfterIssuing\n      usageInformation\n    }\n  }\n  issuingInfo {\n    __typename\n    hasBeenIssued\n  }\n}\n"
  }
};
})();

(node as any).hash = "3ea7c993f35001d779470e8ac57a02af";

export default node;
